import React from 'react';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { TourChecklist } from '@/components/tour/TourChecklist';
import { HeaderHelpMenu } from '@/components/layout/header/HeaderHelpMenu';
import { NotificationsMenu } from '@/components/layout/header/NotificationsMenu';
import { UserMenu } from '@/components/layout/header/UserMenu';
import { useRevenueSummary } from '@/hooks/useRevenueSummary';
import { useVideoNotifications } from '@/hooks/useVideoNotifications';
import { HeaderGreeting } from './HeaderGreeting';

export function DashboardTopbar() {
  // Mesmas fontes reais que alimentavam o sino dentro do Header antigo
  const { recentConversions } = useRevenueSummary();
  const { recentlyReadyVideos } = useVideoNotifications();

  return (
    // "hidden lg:flex" é obrigatório: o Layout renderiza {children} duas vezes
    // (bloco mobile lg:hidden + bloco desktop hidden lg:block). Sem isso a topbar
    // aparece em dobro e os portais (painel de notificações) duplicam.
    // desktop-header também protege contra o display:flex !important global no mobile.
    <header className="desktop-header hidden lg:flex items-center px-6 min-h-[76px] bg-[#F7F9FC] border-none shadow-none">
      <div className="flex items-center justify-between w-full">
        <HeaderGreeting />

        <div className="flex items-center gap-3">
          {/* Âncora do onboarding: vinha do Header e precisa continuar na home */}
          <TourChecklist />

          <div className="flex items-center gap-0">
            <ThemeToggle />
            <HeaderHelpMenu />
            <NotificationsMenu
              recentConversions={recentConversions}
              recentlyReadyVideos={recentlyReadyVideos}
            />
          </div>

          <UserMenu variant="compact" />
        </div>
      </div>
    </header>
  );
}
